import { DisplayText } from "@rentiohq/web-shared/dist/components";
import styled from "@rentiohq/web-theme";

export const Title = styled(DisplayText)`
  margin-bottom: 0 !important;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  gap: 12px;
`;

export const TaskTitle = styled.div`
  color: #494949;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;
